export { default } from './CMSPartial';